module.exports = __webpack_public_path__ + "static/tat-22-308932ce473e518d42360143c2c5746e.jpg";